/******/ (() => { // webpackBootstrap
/*!*******************************************!*\
  !*** ./src/js/product-recommendations.js ***!
  \*******************************************/
/*
BG: This function uses the recommended products API by Shopify. We firstly pass over the product ID we want to display recommended on, and then for each result, request the product.card template to get the look.
*/
document.addEventListener('shopify:section:load', function () {
  recommendedProducts();
});
var recommendedProducts = function recommendedProducts() {
  //determine if the recommendProducts class section is present
  var recommended = document.querySelector('.js-recommended-products');
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recommended.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }
  //if it is....
  if (!!recommended) {
    //Get the productID from the data attribute
    var productID = parseInt(recommended.getAttribute('data-product-id'));

    //using that productID, query the recommended products API
    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(productID, "&limit=").concat(recommended.dataset.limit ? recommended.dataset.limit : '5', "&intent=").concat(recommended.dataset.intent)).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var products = _ref.products;
      //with the response, loop through each product.
      products.forEach(function (product, index) {
        //console.log(product.handle)
        //we run a second fetch to get the product card HTML markup
        fetch(window.Shopify.routes.root + "products/".concat(product.handle, "?view=card")).then(function (response) {
          return response.text();
        }).then(function (html) {
          var flickitySlider = recommended.querySelector('.flickity-slider');
          var newHtml = html;
          newHtml = "<div class=\"w-full relative collection-{{collectionTitle}} carousel-cell mx-0 mr-3 lg:mr-5 w-[48%] lg:w-[23%] group/product-carousel overflow-hidden ".concat(products.length < 2 && ' lg:flex lg:w-full lg:flex-row gap-5', "\">").concat(html, "</div>");

          //if flickity isn't present, it might be that it's not being used at a particular size, so we drop it in the section anyways.
          if (flickitySlider) {
            flickitySlider.innerHTML += newHtml;
          } else {
            recommended.innerHTML += newHtml;
          }

          //if last product, and we're using flickity....
          if (index === products.length - 1 && flickityPresent && flickitySlider) {
            //after a breif delay, re-init flickity.
            setTimeout(function () {
              var flkty = Flickity.data('.js-recommended-products');
              flkty.reloadCells();
              flkty.resize();
            }, 2000);
          }
        });
      });
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  }
  function reinitializeAllReviewsWidgets() {
    if (typeof ratingSnippet === 'function') {
      document.querySelectorAll('.js-recommended-products .product-card .ruk_rating_snippet').forEach(function (element) {
        if (element) {
          ratingSnippet("ruk_rating_snippet", {
            store: "noaandnani-co-uk1",
            mode: "default",
            linebreak: false,
            lang: "en",
            usePolaris: false,
            showEmptyStars: true
          });
        }
      });
    }
  }
  setTimeout(reinitializeAllReviewsWidgets, 2000);
};
recommendedProducts();
/******/ })()
;